import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { BuildingReviewAgentSwitchViewStore } from 'common/module/building-review/agent-switch/view-store';

export function BuildingReviewAgentSwitchViewStoreFactory(): BuildingReviewAgentSwitchViewStore {
  const agentViewStore = new BuildingReviewAgentSwitchViewStore(EventEmitterFactory());

  return agentViewStore;
}
